(() => {
  const mainButton = () => document.querySelector('.product__info-container .product-form__submit');
  const selector = () => document.querySelector('[data-cloud-variant-selector]');
  const sticky = () => document.querySelector('[data-cloud-sticky-buy]');

  const selectedOptions = () => {
    const root = selector();
    if (!root) return [];
    /* customer-facing labels: the swatch's name, the option's display text */
    return Array.from(root.querySelectorAll('fieldset input:checked, select option:checked'))
      .map((option) => {
        if (option.tagName === 'OPTION') return (option.dataset.cloudModelLabel || option.textContent || option.value).trim();
        const label = root.querySelector(`label[for="${option.id}"]`);
        const name = label?.querySelector('.cloud-colour-card__name')?.textContent || label?.getAttribute('aria-label') || option.value;
        const text = String(name).trim();
        return text.charAt(0).toUpperCase() + text.slice(1);
      })
      .filter(Boolean);
  };

  /* Add to cart ships disabled until a model is genuinely chosen, so that a
     product defaulting to iPhone 13 cannot be bought as iPhone 13 by accident.
     Dawn re-renders the section on a variant change and returns it enabled, but
     this releases it immediately either way — a button stuck disabled would
     block every sale on the page. */
  /* The sticky bar is a mirror: its select follows the main select and its
     button follows the main button. Nothing in it depends on render timing. */
  const releaseStickyBar = () => {};

  const releaseAddToCart = () => {
    releaseStickyBar();
    document.querySelectorAll('[data-cc-needs-phone]').forEach((button) => {
      const label = button.querySelector('span');
      if (label && button.dataset.ccReadyLabel) label.textContent = button.dataset.ccReadyLabel;
      button.disabled = false;
      button.querySelector('[data-cloud-button-price]')?.removeAttribute('hidden');
      delete button.dataset.ccNeedsPhone;
    });
  };

  const syncSticky = () => {
    const bar = sticky() || document.createElement('div');
    const sourcePrice = document.querySelector(
      '.product__info-container .price-item--sale.price-item--last, .product__info-container .price-item--regular'
    );
    const price = bar.querySelector('[data-cloud-sticky-price]');
    if (sourcePrice && price) price.textContent = sourcePrice.textContent.trim();
    const sourceCompare = document.querySelector('.product__info-container .price__sale .price-item--regular');
    const compare = bar.querySelector('[data-cloud-sticky-compare]');
    if (compare) {
      compare.hidden = !sourceCompare;
      if (sourceCompare) compare.textContent = sourceCompare.textContent.trim();
    }

    /* Button price and the "3 cases for" line follow the variant price. */
    if (sourcePrice) {
      const priceText = sourcePrice.textContent.trim();
      const buttonPrice = document.querySelector('[data-cloud-button-price]');
      if (buttonPrice) {
        buttonPrice.textContent = `\u00a0\u2014\u00a0${priceText}`;
        const submit = buttonPrice.closest('button');
        if (submit && !submit.disabled && !submit.dataset.ccNeedsPhone) buttonPrice.removeAttribute('hidden');
      }
      const bundle = document.querySelector('[data-cloud-bundle]');
      const match = priceText.match(/[\d.,]+/);
      if (bundle && match) {
        const amount = Number.parseFloat(match[0].replace(/,/g, ''));
        const goal = Number.parseInt(bundle.dataset.goal, 10) || 3;
        if (Number.isFinite(amount)) {
          const total = (amount * (goal - 1)).toFixed(2);
          bundle.querySelector('[data-cloud-bundle-total]').textContent = priceText.replace(match[0], total);
          bundle.querySelector('[data-cloud-bundle-save]').textContent = priceText;
        }
      }
    }

    const selection = bar.querySelector('[data-cloud-sticky-selection]');
    const choices = selectedOptions();
    const quantity = document.querySelector('[data-cloud-quantity-input]')?.value;
    if (Number(quantity) > 1) choices.push(`${quantity} cases`);
    /* model first — it is the thing the shopper needs to see before tapping */
    if (selection && choices.length) {
      const isModel = (c) => /iphone|samsung|galaxy|pixel|\b\d{1,2}\b/i.test(c);
      selection.textContent = [...choices.filter(isModel), ...choices.filter((c) => !isModel(c))].join(' · ');
    }
    const stickyModel = bar.querySelector('[data-cloud-sticky-model]');
    const mainModel = document.querySelector('[data-cloud-phone-input]');
    if (stickyModel && mainModel && mainModel.value && stickyModel.value !== mainModel.value) {
      if ([...stickyModel.options].some((o) => o.value === mainModel.value)) {
        stickyModel.value = mainModel.value;
        stickyModel.querySelector('option[value=""]')?.remove();
      }
    }

    const sourceButton = mainButton();
    const button = bar.querySelector('[data-cloud-sticky-submit]');
    if (!button) return;
    const mainSelect = document.querySelector('[data-cloud-phone-input]');
    const modelChosen = !mainSelect || !!mainSelect.value;
    const buttonText = button.querySelector('span') || button;
    const buttonPrice = button.querySelector('[data-cloud-sticky-btn-price]');
    if (!modelChosen) {
      button.disabled = false;
      button.dataset.stickyMode = 'choose';
      buttonText.textContent = 'Choose your phone';
      if (buttonPrice) buttonPrice.hidden = true;
      return;
    }
    button.dataset.stickyMode = 'add';
    button.disabled = !sourceButton || sourceButton.disabled;
    buttonText.textContent = button.disabled
      ? sourceButton?.querySelector('span')?.textContent.trim() || 'Sold out'
      : bar.dataset.addLabel || 'Add to cart';
    if (buttonPrice) buttonPrice.hidden = true; /* price lives on the page, not the button (Sean) */
  };

  const syncQuantityChoice = (choice) => {
    const root = choice?.closest('[data-cloud-quantity-bundles]');
    if (!root) return;
    const quantityInput = root.querySelector('[data-cloud-quantity-input]');
    if (quantityInput) {
      quantityInput.value = choice.value;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    root.querySelectorAll('.cloud-quantity-bundle').forEach((label) => {
      label.classList.toggle('is-selected', label.contains(choice));
    });
    syncSticky();
  };

  const updateOffer = (itemCount) => {
    document.querySelectorAll('[data-cloud-offer-progress]').forEach((offer) => {
      if (offer.dataset.offerCanUpdate === 'false') return;
      const goal = Number.parseInt(offer.dataset.offerGoal, 10) || 3;
      const progress = itemCount % goal;
      const unlocked = itemCount > 0 && progress === 0;
      const remaining = unlocked ? 0 : goal - progress;
      const completed = unlocked ? goal : progress;
      const message = offer.querySelector('[data-cloud-offer-message]');
      const heading = offer.querySelector('[data-cloud-offer-heading]');
      if (heading) {
        // On the product page the case on screen is the first of the three.
        const countsThis = heading.dataset.countsThis === 'true';
        const afterThis = remaining - 1;
        if (unlocked) heading.textContent = 'Your free case is unlocked.';
        else if (countsThis) {
          heading.textContent = remaining === 1
            ? 'Add this one — it is free.'
            : afterThis === 1 ? 'Add one more — the third is free.' : `Add ${afterThis} more — the third is free.`;
        } else {
          heading.textContent = remaining === 1 ? 'Add one more — it is free.' : `Add ${remaining} more — the third is free.`;
        }
      }
      const count = offer.querySelector('[data-cloud-offer-count]');
      if (count) count.textContent = `${completed}/${goal}`;
      offer.querySelectorAll('[data-cloud-offer-segments] i').forEach((seg, i) => seg.classList.toggle('is-filled', i < completed));
      const meter = offer.querySelector('.cloud-promotion__meter');
      const fill = meter?.querySelector('span');
      const reward = offer.dataset.offerReward || 'offer';
      const eligibleLabel = offer.dataset.offerEligibleLabel || 'eligible items';
      if (message) {
        if (unlocked) message.textContent = `${reward} unlocked`;
        else if (remaining === 1) message.textContent = 'Add 1 more to unlock';
        else message.textContent = `Add ${remaining} more ${eligibleLabel}`;
      }
      if (meter) meter.setAttribute('aria-valuenow', String(completed));
      if (fill) fill.style.setProperty('--cloud-promotion-progress', `${(completed * 100) / goal}%`);
    });
  };

  // Mirrors the Liquid in cloud-promotion-progress: subscription lines are not
  // cases, so they never count toward the bundle. Using cart.item_count here
  // would let a membership fill a slot the Liquid does not.
  const qualifyingCount = (cart) =>
    (cart.items || []).reduce(
      (total, item) => (item.selling_plan_allocation ? total : total + (item.quantity || 0)),
      0
    );

  // Scroll the model select into view and open it. showPicker throws in
  // browsers that gate it behind a user gesture it does not recognise, so the
  // focus is what has to be reliable — the open is a bonus.
  const focusPhoneSelect = () => {
    const select = document.querySelector('[data-cloud-phone-input]');
    if (!select) {
      document
        .querySelector('[data-cloud-variant-selector]')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });
    select.focus({ preventScroll: true });
    try {
      select.showPicker?.();
    } catch (error) {
      /* Opening the list is optional; the select is focused either way. */
    }
  };

  const refreshOffer = () => {
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error('Cart unavailable'))))
      .then((cart) => updateOffer(qualifyingCount(cart)))
      .catch(() => {});
  };

  const observeStickyPurchase = () => {
    const bar = sticky();
    const sourceButton = mainButton();
    if (!bar || !sourceButton) return;
    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Only once the button has scrolled UP out of view. Without the
        // boundingClientRect check the bar also shows while the button is
        // still below the fold, i.e. immediately on page load.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0.15 },
    );
    observer.observe(sourceButton);
  };

  /* ---- Split products -------------------------------------------------
     The supplier caps a product at 100 variants, so one case can live in
     Shopify as two or three products split by phone model. The picker
     (cloud-family-picker) renders the union of every part's colours and
     models; a value that belongs to a sibling product carries that
     sibling's handle. Choosing one swaps the page to the sibling with the
     shopper's colour and model preserved, using Dawn's own product-swap
     path so it looks like any other variant change. */
  const familyRoot = () => document.querySelector('variant-selects[data-cloud-family]');

  const familyMap = (root) => {
    if (root._cloudFamilyMap) return root._cloudFamilyMap;
    try {
      root._cloudFamilyMap = JSON.parse(root.querySelector('[data-cloud-family-map]')?.textContent || '{}');
    } catch (_error) {
      root._cloudFamilyMap = {};
    }
    return root._cloudFamilyMap;
  };

  const familyState = (root) => {
    const colour = root.querySelector('[data-cloud-colour-picker] input:checked')?.dataset.cloudColourKey || '';
    const option = root.querySelector('[data-cloud-phone-input]')?.selectedOptions?.[0];
    const model = option && option.value ? option.dataset.cloudModelKey || '' : '';
    return { colour, model };
  };

  /* Which variant, on which product, did the shopper mean? Exact colour ×
     model first; failing that the nearest match on the axis they changed,
     preferring the product the chosen value came from. */
  const resolveFamilyTarget = (root, changed) => {
    const map = familyMap(root);
    const handles = (root.dataset.cloudFamilyHandles || '').split(',');
    const want = familyState(root);
    want[changed.type] = changed.key;
    let hit = want.colour !== '' || want.model !== '' ? map[`${want.colour}|${want.model}`] : null;
    if (!hit) {
      const matches = Object.entries(map).filter(([key]) =>
        changed.type === 'colour' ? key.startsWith(`${want.colour}|`) : key.endsWith(`|${want.model}`),
      );
      const preferred =
        matches.find(([, value]) => handles[value[0]] === changed.handle && value[2] === 1) ||
        matches.find(([, value]) => handles[value[0]] === changed.handle) ||
        matches[0];
      hit = preferred?.[1];
    }
    if (!hit) return null;
    return { handle: handles[hit[0]], variantId: hit[1] };
  };

  const switchFamilyProduct = (root, target, fromSelect) => {
    const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const url = `${rootPath}/products/${target.handle}`;
    const requestUrl = `${url}?variant=${target.variantId}`;
    const productInfo = root.closest('product-info');
    if (!productInfo || typeof productInfo.handleSwapProduct !== 'function') {
      window.location.assign(requestUrl);
      return;
    }
    root.classList.add('cloud-variant-selector--switching');
    productInfo.abortController?.abort();
    productInfo.abortController = new AbortController();
    fetch(requestUrl, { signal: productInfo.abortController.signal })
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (!html.querySelector("product-info[id^='MainProduct']")) throw new Error('No product in response');
        productInfo.handleSwapProduct(url, true)(html);
        if (fromSelect) document.querySelector('[data-cloud-phone-input]')?.focus({ preventScroll: true });
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        window.location.assign(requestUrl);
      });
  };

  /* Capture phase, so this runs before Dawn's variant-selects listener and
     can stop it: Dawn would ask the current product for an option value it
     does not have. In-product values are left to Dawn untouched. */
  /* A colour tap with no phone chosen used to let Dawn pick "the first
     available variant", i.e. whatever model the supplier listed first
     (an iPhone 14). The select lists models newest first, so the newest
     is chosen instead; a model the shopper already picked carries over. */
  const defaultLatestModel = (picker) => {
    const select = picker.querySelector('[data-cloud-phone-input]');
    if (!select || select.value) return false;
    /* newest generation, then Pro Max > Pro > Plus/Air > standard > mini;
       supplier lists are in no order at all ("iPhone 14" first is typical) */
    const rank = (label) => {
      const key = String(label).toLowerCase().replace(/iphone|apple|\s|-|_/g, '').split('/')[0];
      const gen = parseInt(key, 10) || (/^xs/.test(key) ? 10.5 : /^xr?$/.test(key) ? 10 : /^se/.test(key) ? 8 : 0);
      const tier = key.includes('promax') ? 5 : key.includes('pro') ? 4 : key.includes('plus') || key.includes('air') ? 3 : key.includes('mini') ? 1 : 2;
      return gen * 10 + tier;
    };
    const latest = [...select.options]
      .filter((option) => option.value && !option.disabled)
      .sort((a, b) => rank(b.dataset.cloudModelLabel || b.value) - rank(a.dataset.cloudModelLabel || a.value))[0];
    if (!latest) return false;
    select.value = latest.value;
    /* Dawn reads the option's selected *attribute*, not the live value */
    [...select.options].forEach((option) => option.removeAttribute('selected'));
    latest.setAttribute('selected', 'selected');
    select.querySelector('option[value=""]')?.remove();
    const heading = picker.querySelector('[data-cloud-phone-picker] [data-selected-value]');
    if (heading) heading.textContent = latest.dataset.cloudModelLabel || latest.value;
    return true;
  };

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.matches('input[type="radio"][data-cloud-colour-key], .cloud-product-option--colour input[type="radio"]')) {
        const picker = event.target.closest('variant-selects');
        if (picker) defaultLatestModel(picker);
      }
      const root = event.target.closest('variant-selects[data-cloud-family]');
      if (!root) return;
      let changed;
      if (event.target.matches('[data-cloud-phone-input]')) {
        const option = event.target.selectedOptions?.[0];
        if (!option || !option.value) return;
        changed = { type: 'model', key: option.dataset.cloudModelKey, handle: option.dataset.cloudFamilyHandle };
      } else if (event.target.matches('input[type="radio"][data-cloud-colour-key]')) {
        changed = {
          type: 'colour',
          key: event.target.dataset.cloudColourKey,
          handle: event.target.dataset.cloudFamilyHandle,
        };
      } else {
        return;
      }
      if (changed.type === 'colour') {
        /* the model just defaulted (or already chosen) may live on a sibling */
        const modelOption = root.querySelector('[data-cloud-phone-input]')?.selectedOptions?.[0];
        const modelHandle = modelOption?.dataset.cloudFamilyHandle;
        if (modelHandle && modelHandle !== root.dataset.productHandle) changed.handle = modelHandle;
      }
      if (!changed.handle || changed.handle === root.dataset.productHandle) return;
      const target = resolveFamilyTarget(root, changed);
      if (!target) return;
      event.stopPropagation();
      switchFamilyProduct(root, target, changed.type === 'model');
    },
    true,
  );

  /* The sticky bar's model select is built from the current product only;
     for a split product it mirrors the unified list instead. */
  const syncStickyModelList = () => {
    const source = familyRoot()?.querySelector('[data-cloud-phone-input]');
    const stickyModel = document.querySelector('[data-cloud-sticky-model]');
    if (!source || !stickyModel || stickyModel.dataset.cloudFamilySynced) return;
    stickyModel.innerHTML = source.innerHTML;
    stickyModel.querySelectorAll('[id]').forEach((option) => option.removeAttribute('id'));
    stickyModel.value = source.value;
    stickyModel.dataset.cloudFamilySynced = 'true';
  };

  /* "Make it three" add-ons: add the same phone model the shopper chose
     above, never the product's first variant. The card carries a map of
     model → real variant id; the form's id is swapped before Dawn submits. */
  const currentModelKey = () => {
    const option = document.querySelector('[data-cloud-phone-input]')?.selectedOptions?.[0];
    if (!option || !option.value) return '';
    if (option.dataset.cloudModelKey) return option.dataset.cloudModelKey;
    return option.value.toLowerCase().replace(/iphone|apple|\s|-|_/g, '');
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.product-form__submit[data-cc-needs-phone]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const picker = button.closest('product-info')?.querySelector('variant-selects') || document.querySelector('variant-selects');
      if (picker && defaultLatestModel(picker)) {
        picker.querySelector('[data-cloud-phone-input]')?.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      focusPhoneSelect();
    },
    true,
  );

  document.addEventListener(
    'submit',
    (event) => {
      const card = event.target.closest('[data-cloud-setup-card]');
      if (!card) return;
      const modelKey = currentModelKey();
      if (!modelKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        focusPhoneSelect();
        return;
      }
      let map = {};
      try {
        map = JSON.parse(card.querySelector('[data-cloud-setup-map]')?.textContent || '{}');
      } catch (_error) {}
      const hit = map[modelKey];
      const input = event.target.querySelector('input[name="id"]');
      if (!hit || !input) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(card.dataset.productUrl || '/');
        return;
      }
      input.value = hit[0];
      input.disabled = false;
    },
    true,
  );

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-cloud-sticky-submit]');
    if (!stickyButton) return;
    if (stickyButton.dataset.stickyMode === 'choose') {
      const stickySelect = document.querySelector('[data-cloud-sticky-model]');
      if (stickySelect && stickySelect.offsetParent) {
        stickySelect.focus({ preventScroll: true });
        try {
          stickySelect.showPicker?.();
        } catch (_error) {
          focusPhoneSelect();
        }
      } else {
        focusPhoneSelect();
      }
      return;
    }
    mainButton()?.click();
  });

  document.addEventListener('change', (event) => {
    const stickyModel = event.target.closest('[data-cloud-sticky-model]');
    if (stickyModel) {
      /* Mirror the choice onto the real select and let Dawn's variant-selects
         handle it from there, exactly as if the shopper had used it directly. */
      const target = document.querySelector('[data-cloud-phone-input]');
      if (target && stickyModel.value) {
        target.value = stickyModel.value;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        stickyModel.querySelector('option[value=""]')?.remove();
      }
      window.setTimeout(syncSticky, 0);
      return;
    }

    const quantityChoice = event.target.closest('[data-cloud-quantity-choice]');
    if (quantityChoice) syncQuantityChoice(quantityChoice);

    if (event.target.closest('variant-selects, [data-cloud-phone-picker]')) releaseAddToCart();

    /* Colour is the choice that swaps the gallery image. If the frame has
       scrolled out of view the change happens where nobody can see it, so the
       gallery is brought back before the swap lands. Only when it is actually
       hidden, and never against a reduced-motion preference. */

    const phoneSelect = event.target.closest('[data-cloud-phone-input]');
    if (phoneSelect && phoneSelect.value) {
      const picker = phoneSelect.closest('[data-cloud-phone-picker]');
      /* Dawn only syncs [data-selected-value] for swatch dropdowns, so the
         heading above the select is ours to keep in step. */
      const heading = picker?.querySelector('[data-selected-value]');
      const chosen = phoneSelect.selectedOptions?.[0];
      if (heading) heading.textContent = chosen?.dataset.cloudModelLabel || phoneSelect.value;
      /* A model has been chosen, so the placeholder must not be reachable. */
      phoneSelect.querySelector('option[value=""]')?.remove();
      releaseAddToCart();
      try {
        window.localStorage.setItem('cloudPhoneModel', phoneSelect.value);
      } catch (_error) {}
    }
    window.setTimeout(syncSticky, 0);
  });

  const initialised = new WeakSet();

  /* The shopper's own earlier choice (this select, or the homepage phone
     control) opens the select on that model. Only when the URL carries no
     variant and the option exists; a guess is never made. */
  const restorePhoneModel = () => {
    const select = document.querySelector('[data-cloud-phone-input]');
    if (!select || select.value) return;
    let stored = '';
    try { stored = window.localStorage.getItem('cloudPhoneModel') || ''; } catch (_error) {}
    if (!stored) return;
    const key = (value) => String(value).toLowerCase().replace(/\b(apple|iphone|samsung|galaxy|google|pixel)\b/g, '').replace(/[^a-z0-9/]+/g, '');
    const match = [...select.options].find((option) => option.value && (key(option.value) === key(stored) || key(option.dataset.cloudModelLabel || '') === key(stored)));
    if (!match) return;
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  /* No variant in the URL and nothing remembered: open on the newest model
     so the page is buyable from the first tap (Sean, 14 Sep). The select
     sits right above the button, so the choice is visible and changeable. */
  const defaultOnLoad = () => {
    const select = document.querySelector('[data-cloud-phone-input]');
    if (!select || select.value) return;
    const picker = select.closest('variant-selects');
    if (picker && defaultLatestModel(picker)) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const initProductPage = () => {
    syncStickyModelList();
    restorePhoneModel();
    defaultOnLoad();
    if (document.querySelector('[data-cloud-phone-input]')?.value) releaseAddToCart();
    syncSticky();
    observeStickyPurchase();

    const productInfo = document.querySelector('product-info');
    if (productInfo && !initialised.has(productInfo)) {
      initialised.add(productInfo);
      // syncSticky() writes textContent inside product-info, so observing it
      // naively made the callback retrigger itself without end and locked up
      // the main thread. Disconnect while mutating, and coalesce bursts into a
      // single frame.
      const OBSERVE = { subtree: true, childList: true };
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(() => {
          observer.disconnect();
          try {
            syncSticky();
          } finally {
            observer.observe(productInfo, OBSERVE);
            queued = false;
          }
        });
      });
      observer.observe(productInfo, OBSERVE);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductPage();
    refreshOffer();

    /* Fired by each product-info as it connects — including the one Dawn
       inserts when the page swaps to a sibling of a split product. */
    document.addEventListener('product-info:loaded', () => window.setTimeout(initProductPage, 0));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshOffer);
      /* A beat of feedback on the button itself after an add: "✓ Added to bag", then back. */
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source !== 'product-form') return;
        const button = mainButton();
        const label = button?.querySelector('span');
        if (!button || !label || button.dataset.ccAddedTimer) return;
        const original = label.textContent;
        const price = button.querySelector('[data-cloud-button-price]');
        label.textContent = '\u2713 Added to bag';
        if (price) price.hidden = true;
        button.classList.add('is-added');
        button.dataset.ccAddedTimer = String(
          window.setTimeout(() => {
            label.textContent = original;
            if (price && !button.dataset.ccNeedsPhone) price.hidden = false;
            button.classList.remove('is-added');
            delete button.dataset.ccAddedTimer;
          }, 1600),
        );
      });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(syncSticky, 0));
      /* WebKit sometimes ignores the gallery's scrollTo() on a scroll-snap
         list right after new media is inserted, so the colour's photo never
         comes into view. Bring the active slide in explicitly, twice. */
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        const bring = () => {
          const active = document.querySelector('.product__media-list li.is-active');
          const list = active?.parentElement;
          if (!active || !list) return;
          const left = active.offsetLeft;
          if (Math.abs(list.scrollLeft - left) > 4) {
            try {
              list.scrollTo({ left, behavior: 'instant' });
            } catch (_error) {
              list.scrollLeft = left;
            }
          }
        };
        window.setTimeout(bring, 60);
        window.setTimeout(bring, 450);
      });
    }
  });
})();
